import {Link, withRouter} from 'react-router-dom'
import Cookies from 'js-cookie'
import './index.css'

const Header = props => {
  const onClickLogout = () => {
    Cookies.remove('jwt_token')
    const {history} = props
    history.replace('/login')
  }

  return (
    <nav className="header-container">
      <Link to="/">
        <img
          src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
          alt="website logo"
          className="website-logo"
        />
      </Link>
      <ul className="nav-links">
        <li>
          {' '}
          <Link to="/">Home</Link>{' '}
        </li>
        <li>
          {' '}
          <Link to="/jobs">Jobs</Link>{' '}
        </li>
        <li>
          {' '}
          <button type="button" onClick={onClickLogout}>
            {' '}
            Logout{' '}
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default withRouter(Header)
